import { Table } from 'antd'
import { ProposedTenant } from '../../../models'
import { buildUsersTableColumns } from './users-table-columns'

interface Props {
  tenant: ProposedTenant
}

export const UsersPanel = ({ tenant }: Props) => {
  return (
    <Table
      columns={buildUsersTableColumns()}
      dataSource={tenant?.users}
      loading={!tenant}
      rowKey="id"
      pagination={false}
      size="small"
    />
  )
}
